// extracted by mini-css-extract-plugin
export var loadingSpinner = "_2r-0";
export var spinnerContainer = "_2r-1";